export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const WEB_REG_EXP = /^(http(s)?\:\/\/)?www\.\w{1,}\.\w{2,}/g;

export const SLUG_VALIDATION_REG_EXP = /^[a-z0-9]+([a-z0-9_-])*([a-z0-9])+$/;

export const URL_PROTOCOL_CHECK_REG_EXP = /^((http|https|ftp):\/\/)/;
